import { SessionLevelTracking } from "@gocardless/session-level-tracking";

export const sessionTracking = new SessionLevelTracking();
